export const SUPPORT_EMAIL = "globalvision855@gmail.com";

export const INFO_PAGES = {
  privacy: {
    title: "Privacy Policy",
    type: "prose",
    blocks: [
      { p: "LaunchBS respects your privacy." },
      { p: "We only collect information necessary to provide and improve our services. Depending on the features you use, this may include:" },
      { ul: ["Account information you provide", "Subscription information", "Preferences you choose to save", "Information you voluntarily submit through forms"] },
      { p: "LaunchBS does not sell your personal information." },
      { p: "LaunchBS may include links to third-party websites. Those websites have their own privacy practices, and LaunchBS is not responsible for their content or policies." },
      { p: "If analytics or cookies are used, they help improve the user experience and understand how the platform is used." },
      { email: "Questions regarding privacy may be sent to:" },
    ],
  },
  terms: {
    title: "Terms of Service",
    type: "prose",
    blocks: [
      { p: "LaunchBS provides educational content, startup planning tools, and curated links to third-party platforms." },
      { p: "Users are responsible for evaluating third-party services before using them." },
      { p: "LaunchBS does not guarantee:" },
      { ul: ["Startup success", "Investment returns", "Business profitability", "Results from third-party platforms"] },
      { p: "Subscription purchases provide access to premium LaunchBS features according to the selected plan." },
      { p: "Users agree not to misuse the platform or copy proprietary LaunchBS content without permission." },
      { p: "LaunchBS may update features and services over time." },
    ],
  },
  cookies: {
    title: "Cookie Policy",
    type: "prose",
    blocks: [
      { p: "LaunchBS may use cookies or similar technologies to:" },
      { ul: ["Keep users signed in", "Remember preferences", "Improve platform performance", "Understand general usage trends"] },
      { p: "Users may manage cookies through their browser settings." },
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    type: "prose",
    blocks: [
      { p: "LaunchBS provides educational content, startup planning tools, AI-powered guidance, and curated third-party resources." },
      { p: "Information provided through LaunchBS is for informational purposes only and should not be considered legal, financial, investment, accounting, or professional advice." },
      { p: "LaunchBS does not guarantee startup success, revenue, funding, customer growth, or business outcomes." },
      { p: "Any third-party products, services, or platforms recommended through the Founder Resource Library remain independent of LaunchBS. Users should evaluate those services before making decisions." },
    ],
  },
  help: {
    title: "Help Center",
    subtitle: "Find answers to common questions about LaunchBS.",
    type: "help",
    sections: [
      { title: "Getting Started", text: "Learn how to begin your startup journey." },
      { title: "AI Resources", text: "Information about LaunchBS tools and external resources." },
      { title: "Blueprint AI", text: "Learn how Blueprint AI works and what is included with a subscription." },
      { title: "Founder Resource Library", text: "Learn how to discover trusted third-party platforms." },
      { title: "Account", text: "Manage your account and subscription." },
    ],
    contact: { title: "Contact Support", text: "Need additional help?" },
  },
  faq: {
    title: "Frequently Asked Questions",
    subtitle: "Answers to the questions founders ask us most.",
    type: "faq",
    items: [
      { q: "What is LaunchBS?", a: "LaunchBS is a startup platform designed to help founders discover ideas, validate them, plan products, and find trusted tools for building and growing a business." },
      { q: "Is LaunchBS free?", a: "Many resources are available for free. Some advanced features, including Blueprint AI, require a subscription." },
      { q: "Does LaunchBS build my app?", a: "No. LaunchBS helps founders generate plans, blueprints, and recommendations, then connects them with development platforms where they can build their applications." },
      { q: "Does LaunchBS guarantee business success?", a: "No. LaunchBS provides educational resources and planning tools. Success depends on execution, market demand, competition, and many other factors." },
      { q: "Can I recommend a new resource?", a: "Yes. Use the Contact page to suggest tools or platforms for the Founder Resource Library." },
    ],
  },
};
